export const globalDefines = {
    defaultToastDuration    : 3000,     // Duració en mil·lisegons
    minPasswordLength       : 6,        // Número de caràcters
    limitScrollOriginal     : 10,       // Número de peticions
    loadingTimeoutCheck     : 0,        // Timeout en mil·lisegons
    notificationDelay       : 5,        // Delay en minuts
    timerDelay              : 40000,    // Delay en mil·lisegons

    polygonFillColor        : '#0000FF',
    polygonFillOpacity      : 0.35,
    polygonStrokeColor      : '#0000FF',
    polygonStrokeOpacity    : 0.8,
    polygonStrokeWeight     : 2,

    drawingPolygonFillColor        : '#FF0000',
    drawingPolygonFillOpacity      : 0.35,
    drawingPolygonStrokeColor      : '#FF0000',
    drawingPolygonStrokeOpacity    : 0.8,
    drawingPolygonStrokeWeight     : 2,
}

export const propertyNames = {
    Checks          : 'checks',
    Geolocation     : 'geolocation',
    LastCheck       : 'lastCheck',
    LastTimetable   : 'lastTimetable',
    Name            : 'name',
    Notification    : 'notification',
    State           : 'state',
    UUID_device     : 'uuid_device',
    Workplace       : 'workplace'
}

export const tableNames = {
    Checks      : 'checks',
    Frauds      : 'frauds',
    Keys        : 'keys',
    Properties  : 'properties',
    Repo        : '',
    Timetables  : 'timetables',
    User        : 'users',
    UserChecks  : 'userChecks',
    Workplace   : 'workplaces'
}

export const availableReports = [
    { name: 'Resumen usuario',  admin: false,  page: 'ReportUserPage' },
    { name: 'Resumen global',   admin: true,   page: 'ReportGlobalPage' },
]

export const backdoorKey: Array<any> = [0, 0, 'left', 'left', 'left', 'left', 'right', 'right'];

export const statusLights = {
    in: './../assets/imgs/green.png',
    out: './../assets/imgs/red.png',
    paused: './../assets/imgs/yellow.png',
}

export const version = '1.3.6'


// WEBPACK FOOTER //
// ./src/app/app.constants.ts